import { NavLink } from "react-router-dom";
import {
  Home, ShoppingBasket, Bike, Smartphone, Flame, Store, Package, Car, Ticket, Heart, UserCog, LifeBuoy,
  LayoutDashboard, ShieldCheck, BadgePlus,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useSite } from "../context/SiteContext";
import { iconFor, isExternal } from "../lib/icons";

export const NAV = [
  { to: "/", label: "Início", icon: Home, end: true },
  { to: "/catalogo", label: "BÔ Market", icon: ShoppingBasket },
  { to: "/obogo", label: "OBÔGO Mobilidade", icon: Bike },
  { to: "/recargas", label: "Recargas Digitais", icon: Smartphone },
  { to: "/ofertas", label: "Ofertas do Dia", icon: Flame },
  { to: "/lojas", label: "Lojas e Parceiros", icon: Store },
  { to: "/conta/pedidos", label: "Meus Pedidos", icon: Package },
  { to: "/conta/transportes", label: "Meus Transportes", icon: Car },
  { to: "/conta/passes", label: "Meus Passes", icon: Ticket },
  { to: "/favoritos", label: "Favoritos", icon: Heart },
  { to: "/conta/perfil", label: "Perfil e Pagamentos", icon: UserCog },
  { to: "/ajuda", label: "Ajuda e Suporte", icon: LifeBuoy },
];

const slug = (to) => (to === "/" ? "inicio" : to.replace(/\//g, "-").slice(1));

export function NavList({ onNavigate }) {
  const { user } = useAuth();
  const { site } = useSite();
  const nav = site ? site.menu.filter((m) => m.active).map((m) => ({ to: m.link || "/", label: m.label, icon: iconFor(m.icon), end: m.link === "/" })) : NAV;
  const extra = [];
  if (user?.role === "store") extra.push({ to: "/painel-loja", label: "Painel da Loja", icon: LayoutDashboard });
  if (user?.role === "courier") extra.push({ to: "/estafeta", label: "Painel do Estafeta", icon: Bike });
  if (user?.is_staff) extra.push({ to: "/admin", label: "Administração", icon: ShieldCheck });
  if (!user || user.role === "customer") extra.push({ to: "/vender", label: "Vender no BÔ Market", icon: BadgePlus });
  const cls = "group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-gray-600 transition-colors hover:bg-bo-green/5 hover:text-bo-green";
  const item = ({ to, label, icon: Icon, end }) => (isExternal(to)
    ? <a key={to} href={to} target="_blank" rel="noopener noreferrer" className={cls} data-testid={`nav-ext-${label}`}><Icon className="h-[18px] w-[18px] shrink-0" /><span className="truncate">{label}</span></a> :
    <NavLink key={to} to={to} end={end} onClick={onNavigate} data-testid={`nav-${slug(to)}`}
      className={({ isActive }) => `group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors ${
        isActive ? "bg-bo-green text-white shadow-sm" : "text-gray-600 hover:bg-bo-green/5 hover:text-bo-green"}`}>
      <Icon className="h-[18px] w-[18px] shrink-0" />
      <span className="truncate">{label}</span>
    </NavLink>
  );
  return (
    <nav className="flex flex-col gap-1">
      {nav.map(item)}
      {extra.length > 0 && <div className="my-2 border-t border-gray-100" />}
      {extra.map(item)}
    </nav>
  );
}

export default function Sidebar() {
  return (
    <aside className="hidden lg:block" data-testid="sidebar">
      <div className="bo-card sticky top-[88px] p-3">
        <NavList />
        <p className="mt-4 px-3 text-[11px] text-gray-400">Uma iniciativa BSGOTECH</p>
      </div>
    </aside>
  );
}
